/*
  Gate di consenso per la live chat LiveChat (livechat.com) — issue #444,
  passaggio da Gorgias a LiveChat deciso dal committente il 28/09/2026.
  FAIL-CLOSED, stesso schema di assets/gorgias-consent-gate.js (N6, #832/#838).

  Perché un gate nostro: l'installazione standard dall'app Shopify LiveChat
  passa dall'app embed del tema («Add chat widget» → editor tema → Save; doc
  «Shopify: Install LiveChat in your store», livechat.com/help, agg. 02/04/2025,
  letta il 28/09/2026) e nessuna fonte ufficiale LiveChat dichiara che quel
  caricamento attenda la Customer Privacy API di Shopify. Il widget scrive i
  cookie lc_cid (ID cliente) e lc_cst (token di sicurezza), durata 2 anni
  (doc «Improving your cookie banner: A guide for LiveChat», agg. 10/02/2025):
  un identificatore persistente, quindi prima del consenso non deve partire
  nulla. L'app embed LiveChat resta SPENTO; il codice lo carica solo questo
  file.

  Come funziona (uguale al gate Gorgias):
  - legge dal proprio tag <script>
      data-livechat-license  → numero di licenza LiveChat (solo cifre; valore
                               non numerico = nessun caricamento)
      data-livechat-consent  → "marketing" (default, il più restrittivo) oppure
                               "preferences" (funzionale, solo dopo la
                               classificazione del consulente legale)
      data-livechat-market / data-livechat-locale / data-livechat-currency
                             → variabili di sessione NON personali per
                               l'operatore (mercato, lingua, valuta)
  - chiede all'API Customer Privacy di Shopify se il trattamento è consentito
    (marketingAllowed() / preferencesProcessingAllowed(): true con consenso
    dato o nelle regioni senza obbligo di banner);
  - decisione in sospeso → resta in ascolto di visitorConsentCollected e
    carica all'accettazione, senza ricaricare la pagina;
  - API assente, in errore o non caricabile → NESSUN caricamento.

  Cosa carica con il consenso: il codice di tracciamento ufficiale LiveChat
  (stub LiveChatWidget v2.0 + https://cdn.livechatinc.com/tracking.js), dalla
  doc «Chat Widget JS API» (platform.text.com, letta il 28/09/2026). Poi
  emette l'evento document «vietti:livechat-loaded», che attiva il lanciatore
  custom (assets/livechat-widget.js).

  Domini del fornitore (doc «LiveChat security and data storage» e «Use
  LiveChat with Content Security Policy», agg. 05/08/2026): *.livechatinc.com,
  *.livechat-static.com, *.livechat-files.com, *.files-text.com, *.text.com,
  *.livechat.com. Con il rifiuto: zero richieste verso questi domini.

  Diagnostica: <html data-livechat-chat="gated|loaded"> (letto dal collaudo).
*/
(function () {
  'use strict';

  var gateScript = document.currentScript || document.querySelector('script[data-livechat-license]');
  if (!gateScript) return;

  var license = (gateScript.getAttribute('data-livechat-license') || '').trim();
  var mode = (gateScript.getAttribute('data-livechat-consent') || 'marketing').trim().toLowerCase();
  if (!/^\d+$/.test(license)) return; // FAIL-CLOSED: licenza assente o non valida
  if (mode !== 'preferences') mode = 'marketing';

  var sessionVariables = {};
  [['market', 'data-livechat-market'], ['locale', 'data-livechat-locale'], ['currency', 'data-livechat-currency']]
    .forEach(function (pair) {
      var value = (gateScript.getAttribute(pair[1]) || '').trim();
      if (value) sessionVariables[pair[0]] = value;
    });

  document.documentElement.setAttribute('data-livechat-chat', 'gated');

  var loaded = false;

  function loadLiveChat() {
    if (loaded) return;
    loaded = true;
    window.__lc = window.__lc || {};
    window.__lc.license = Number(license);
    // Codice di tracciamento ufficiale LiveChat (stub v2.0), invariato.
    (function (n, t, c) {
      function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n); }
      var e = {
        _q: [], _h: null, _v: '2.0',
        on: function () { i(['on', c.call(arguments)]); },
        once: function () { i(['once', c.call(arguments)]); },
        off: function () { i(['off', c.call(arguments)]); },
        get: function () {
          if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
          return i(['get', c.call(arguments)]);
        },
        call: function () { i(['call', c.call(arguments)]); },
        init: function () {
          var s = t.createElement('script');
          s.async = !0;
          s.type = 'text/javascript';
          s.src = 'https://cdn.livechatinc.com/tracking.js';
          t.head.appendChild(s);
        }
      };
      !n.__lc.asyncInit && e.init();
      n.LiveChatWidget = n.LiveChatWidget || e;
    })(window, document, [].slice);

    if (Object.keys(sessionVariables).length) {
      window.LiveChatWidget.call('set_session_variables', sessionVariables);
    }
    document.documentElement.setAttribute('data-livechat-chat', 'loaded');
    document.dispatchEvent(new CustomEvent('vietti:livechat-loaded'));
  }

  function allowedFromApi(api) {
    return mode === 'preferences' ? api.preferencesProcessingAllowed() : api.marketingAllowed();
  }

  function allowedFromEvent(detail) {
    return mode === 'preferences' ? detail.preferencesAllowed === true : detail.marketingAllowed === true;
  }

  // Accettazione dal banner a pagina aperta: la chat compare senza ricaricare.
  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event && event.detail;
    if (detail && allowedFromEvent(detail)) loadLiveChat();
  });

  function evaluate(api) {
    try {
      if (allowedFromApi(api)) loadLiveChat();
      // Rifiuto o decisione in sospeso: nessuna richiesta.
    } catch (e) {
      // FAIL-CLOSED: errore dell'API = consenso non determinabile.
    }
  }

  function apiUsable(api) {
    return !!api &&
      typeof api.marketingAllowed === 'function' &&
      typeof api.preferencesProcessingAllowed === 'function';
  }

  var api = window.Shopify && window.Shopify.customerPrivacy;
  if (apiUsable(api)) {
    evaluate(api);
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        var loadedApi = window.Shopify && window.Shopify.customerPrivacy;
        if (error || !apiUsable(loadedApi)) return; // FAIL-CLOSED
        evaluate(loadedApi);
      }
    );
  }
  // else: nessuna API di consenso → FAIL-CLOSED.
})();
